import React, { Component } from "react";
import ReactDOM from 'react-dom'; 
import axios from "axios";
import { LangContext } from "../LangContext.jsx";
import Picker from 'react-month-picker';
import 'react-month-picker/css/month-picker.css';
class GeneratePeriodsModal extends Component {
    static contextType = LangContext;

    constructor(props) {
        super();
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;  

        this.state = { 
            documents:[], 
            selectedDocuments: {},
            rangeValue: { from: { year: currentYear, month: currentMonth }, to: { year: currentYear, month: currentMonth } },  
        }; 
        this.handleOpenModalGeneratePeriods = this.handleOpenModalGeneratePeriods.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.pickRange = React.createRef();
        this.handleSelectAll = this.handleSelectAll.bind(this);
    } 

    handleSelectAll() {
        const allSelected = Object.values(this.state.selectedDocuments).every(v => v);
        const newSelectedDocuments = Object.keys(this.state.selectedDocuments).reduce((acc, id) => ({
            ...acc,
            [id]: !allSelected,
        }), {});
        this.setState({ selectedDocuments: newSelectedDocuments });
    }
    async getDocuments(){
        const url = '/api/providers/dossiers/documents/recurrents/'+this.props.person_provider_id;
        const response = await axios.get(url);
        const documents = response.data;
        if(documents.length== 0){
            swal.fire({
                text: "No cuentas con plantillas de recurrencia mensuales",
                icon: "info",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            })
        }else{
            $('#generatePeriodsModal').modal('show');
            const selectedDocuments = documents.reduce((acc, doc) => ({ ...acc, [doc.document.id]: true }), {});
            this.setState({ documents, selectedDocuments });
        } 
    }

    handleOpenModalGeneratePeriods() { 
        this.getDocuments(); 
    }

    handleCheckboxChange(event, id) {
        const { checked } = event.target;
        this.setState(prevState => ({
            selectedDocuments: {
                ...prevState.selectedDocuments,
                [id]: checked,
            }
        }));
    }

    handleButtonClick() {
        const { selectedDocuments, rangeValue } = this.state;
        const selectedDocumentIds = Object.keys(selectedDocuments).filter(id => selectedDocuments[id]);        
        axios.post('/api/periods/generate', {
            documents: selectedDocumentIds,
            from_year: rangeValue.from.year,
            from_month: rangeValue.from.month,
            to_year: rangeValue.to.year,
            to_month: rangeValue.to.month,
            person_provider_id:this.props.person_provider_id,
            action:'generate'
        })
        .then(response => {
            console.log(response.data)
            let message;
            let icon;
            if(response.data.generatedDocuments == true){
                message = 'Las solicitudes de documento fueron generadas con éxito';
                icon = 'success';
            }else{
                message = 'No se generaron documentos en el periodo seleccionado';
                icon = 'info';
            }
            swal.fire({
                text: message,
                icon:  icon,
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                location.reload()
            });
        })
        .catch(error => {
            
            console.error(error);
        });
    }

    handleRangeChange = (year, month, idx) => { 
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1; 
        if (year > currentYear || (year === currentYear && month > currentMonth)) {
            swal.fire({
                text: 'No es posible generar periodos posteriores al mes actual',
                icon: "warning",
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            })
            return;
            
        }
        const { rangeValue } = this.state;
        const newRangeValue = { ...rangeValue };
        if (idx === 0) {
            newRangeValue.from = { year, month };
        } else {
            newRangeValue.to = { year, month };
        }

        this.setState({ rangeValue: newRangeValue });
    };

    handleRangeDismiss = (value) => {
        console.log('Range dismissed:', value);
    };

    handleClickRangeBox = () => {
        this.pickRange.current.show();
    };

    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };

        const makeText = (m) => {
            if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year);
            return '?';
        };

        const { rangeValue, documents, selectedDocuments } = this.state;
        const { lang } = this.context;

        return (
            <div className="modal fade" id="generatePeriodsModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content" style={{ background: '#f5f5f5' }}>
                        <div className="modal-body px-15 py-10 ">
                            <h5 className="text-dark font-weight-bold my-1 mr-5">
                                Generar solicitud de documentos históricos
                            </h5>
                            <div className="text-muted">
                                Selecciona el periodo de los documentos históricos a solicitar.
                            </div>
                        {documents.length > 0 &&
                                    <>
                            <div className="card card-custom gutter-b my-5"> 
                            
                                <div className="card-body pt-5">  
                                <div className="mb-5">
                                        <div className="col-md-12">
                                            <table>
                                                <tr>
                                                    <td></td>
                                                    <td className="datepicker-text">Del</td>
                                                    <td className="datepicker-text text-date-right">Hasta</td>
                                                </tr>
                                                <tr>
                                                    <td className="pr-3">
                                                        Periodo
                                                    </td>
                                                    <td colSpan={2}> <Picker
                                                ref={this.pickRange}
                                                years={{ min: 2013 }}
                                                range={true}
                                                value={rangeValue}
                                                lang={pickerLang}
                                                theme="light"
                                                onChange={this.handleRangeChange}
                                                onDismiss={this.handleRangeDismiss}
                                            >
                                                <div className="month-box" onClick={this.handleClickRangeBox}>
                                                        <span>{makeText(rangeValue.from)}</span> 
                                                        <span>{makeText(rangeValue.to)}</span>
                                                        <i class="flaticon2-down icon-sm"></i>
                                                </div>
                                            </Picker>
                                            </td>
                                                </tr>
                                            </table>
                                        </div> 
                                    </div>
                                        <h5 className="text-dark font-size-h6 font-weight-bold my-1 mr-5">  Se generarán las solicitudes de documento de las siguientes plantillas mensuales en el período seleccionado.</h5>
                                        <div className="d-flex align-items-center py-2 px-4 mb-2">
                                            <div className="symbol symbol-40 symbol-white"> 
                                                <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                                    <div className="checkbox-inline">
                                                        <label className="checkbox checkbox-outline mb-7">
                                                            <input type="checkbox"
                                                                checked={Object.values(selectedDocuments).every(v => v)}
                                                                onChange={this.handleSelectAll} />
                                                                <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                        </label>
                                                    </div>
                                                </span>
                                            </div>
                                            <span>Seleccionar Todos</span>
                                        </div> 
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th>Nombre de plantilla de documento</th> 
                                                    <th>Frecuencia</th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documents.map((doc, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <div className="checkbox-inline">
                                                                <label className="checkbox checkbox-outline mb-7">
                                                                    <input 
                                                                        type="checkbox" 
                                                                        name="extensions"  
                                                                        checked={selectedDocuments[doc.document.id] || false}
                                                                        onChange={(e) => this.handleCheckboxChange(e, doc.document.id)} 
                                                                    />
                                                                    <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <i className="flaticon2-files-and-folders icon-lg mr-3 text-primary"></i>
                                                                {doc.document.title}
                                                            </div> 
                                                        </td>
                                                        <td> {doc.document.period}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div> 
                            </div> 
                            <div className="text-right mb-5 ">
                                <button className="btn mr-5 btn-secondary font-weight-bolder px-10"   data-dismiss="modal"  >    Cancelar    </button>
                                <button className="btn btn-primary font-weight-bolder px-10"   onClick={this.handleButtonClick}  > Generar  </button>
                            </div>   
                            </>
                            }
                            {documents.length == 0 && 
                                    <>
                                        <h5 className="text-dark font-weight-bold my-1 mr-5">
                                            No cuentas con plantillas de recurrencia mensual
                                        </h5> 
                                    </>
                            }
                        </div> 
                    </div>
                </div>
            </div>
        );
    }
}

export default GeneratePeriodsModal;

if (document.getElementById('GeneratePeriodsModal')) {
    ReactDOM.render(<GeneratePeriodsModal />, document.getElementById('GeneratePeriodsModal'));
}
